// Start animation function
function animateMarquee($marqueeInner, speed, originalContentWidth, direction, gap) {
    const currentPosition = parseInt($marqueeInner.css('transform').split(',')[4]) || 0;
    
    // Calculate new position based on direction
    let newPosition;
    if (direction === 'right') {
        newPosition = currentPosition + (speed / 60); // Move right (positive)
    } else {
        newPosition = currentPosition - (speed / 60); // Move left (negative) - default
    }
    
    // Reset position based on direction
    if (direction === 'right') {
        // For right movement, reset when we reach 0 (start position of left direction)
        if (newPosition >= 0) {
            $marqueeInner.css({
                'transform': 'translateX(-' + (originalContentWidth + gap) + 'px)',
                'transition': 'none'
            });
            // Force reflow
            $marqueeInner[0].offsetHeight;
            requestAnimationFrame(() => animateMarquee($marqueeInner, speed, originalContentWidth, direction, gap));
            return;
        }
    } else {
        // For left movement, reset when we've moved past the original content width in negative direction
        if (Math.abs(newPosition) >= (originalContentWidth + gap)) {
            $marqueeInner.css({
                'transform': 'translateX(0px)',
                'transition': 'none'
            });
            // Force reflow
            $marqueeInner[0].offsetHeight;
            requestAnimationFrame(() => animateMarquee($marqueeInner, speed, originalContentWidth, direction, gap));
            return;
        }
    }
    
    $marqueeInner.css({
        'transform': `translateX(${newPosition}px)`,
        'transition': 'transform 0.016s linear' // 16ms for 60fps
    });
    
    // Continue animation
    requestAnimationFrame(() => animateMarquee($marqueeInner, speed, originalContentWidth, direction, gap));
}

// Initialize marquee functionality
function initMarquee() {
    // Find any element with marquee data attributes
    $('[data-marquee-speed]').each(function() {
        const $marquee = $(this);
        const $marqueeInner = $marquee.find('[marquee-inner]');
        const $items = $marqueeInner.find('[marquee-item]');
        const speed = parseInt($marquee.data('marquee-speed')) || 100;
        const direction = $marquee.data('marquee-direction') || 'left'; // Default to left
        const gap = parseInt($marquee.data('marquee-gap')) || 0; // Default to 0, no gap
        
        // Don't initialize if no items or already initialized
        if ($items.length === 0 || $marquee.hasClass('marquee-initialized')) {
            return;
        }
        
        // Clone items to create seamless loop
        $items.clone().appendTo($marqueeInner);
        
        // Calculate the width of the original content (before cloning) in pixels
        let originalContentWidth = 0;
        $items.each(function(index) {
            originalContentWidth += $(this).outerWidth(true);
            // Add gap for each item except the last one
            if (index < $items.length - 1) {
                originalContentWidth += gap; // Use the configurable gap
            }
        });
        
        // Set initial position based on direction
        if (direction === 'right') {
            // For right movement, start where left ends (-(originalContentWidth + gap))
            $marqueeInner.css({
                'transform': 'translateX(-' + (originalContentWidth + gap) + 'px)',
                'transition': 'none'
            });
        } else {
            // For left movement, start where right ends (0)
            $marqueeInner.css({
                'transform': 'translateX(0px)',
                'transition': 'none'
            });
        }
            
        // Mark as initialized and start animation
        $marquee.addClass('marquee-initialized');
        animateMarquee($marqueeInner, speed, originalContentWidth, direction, gap);
    });
}

jQuery(document).ready(function ($) {
    // Initialize on page load
    initMarquee();
    
    // Re-initialize on window resize (in case layout changes)
    let resizeTimer;
    $(window).on('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
            $('.homepageInsta__marquee').removeClass('marquee-initialized');
            initMarquee();
        }, 250);
    });
    
    // Pause on hover (optional enhancement)
    $('.homepageInsta__marquee').on('mouseenter', function() {
        $(this).addClass('marquee-paused');
    }).on('mouseleave', function() {
        $(this).removeClass('marquee-paused');
    });
});